import React, { useEffect, useState } from 'react';
import Logo from '~/models/Logo';
import { checkFeatureFlag } from '../../modules/helpers';

function AppLogo({ className, logoType, maxHeight, maxWidth, height, theme }) {
    const [logo, setLogo] = useState(SETTINGS.logo); // ab: if backend is down, show default logo?
    const [isDefault, setIsDefault] = useState(true);

    const getLogo = () => {
        if (!checkFeatureFlag('full_csoar'))
            return setLogo(APP_URL.images + '/AS_logo.png');
        Logo.getLogo(logoType).then(response => {
            if (!response.data.default) {
                setLogo(response.data.src);
                setIsDefault(false);
            }
        });
    };

    useEffect(() => {
        getLogo();
    }, []);

    return logo ? (
        <img
            className={`${className} ${
                isDefault && theme === 'light' ? 'is-' : 'not-'
            }inverted`}
            style={{
                height: height,
                maxHeight: maxHeight,
                maxWidth: maxWidth
            }}
            src={`${logo}`}
            alt={'logo'}
        />
    ) : null;
}

export default AppLogo;
